/**
 * @generated SignedSource<<2d7ee1c1d6daf84ebca43ff0cb90cfcc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnifiedProfileQuery$variables = {
  aaid?: string | null;
  internalId?: string | null;
  username?: string | null;
};
export type UnifiedProfileQuery$data = {
  readonly unified: {
    readonly atlassianProducts: {
      readonly " $fragmentSpreads": FragmentRefs<"AtlassianProductsFragment">;
    } | null;
    readonly unifiedProfile: {
      readonly extensions?: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly identifier?: string | null;
      readonly message?: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"UnifiedProfileFragment">;
    } | null;
  } | null;
};
export type UnifiedProfileQuery = {
  response: UnifiedProfileQuery$data;
  variables: UnifiedProfileQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aaid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "internalId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v3 = [
  {
    "kind": "Variable",
    "name": "aaid",
    "variableName": "aaid"
  },
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "internalId"
  },
  {
    "kind": "Variable",
    "name": "unifiedProfileUsername",
    "variableName": "username"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bio",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "company",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "aaid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "linkedinUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "accountInternalId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "location",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "products",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "role",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "username",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "websiteUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "xUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "youtubeUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isPrivate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isPersonalView",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isLinkedView",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isProfileBanned",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isProfileOwnerConsented",
    "storageKey": null
  }
],
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedQueryErrorExtension",
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedQueryError",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "UnifiedProfileFragment",
                    "selections": (v5/*: any*/),
                    "args": null,
                    "argumentDefinitions": []
                  }
                ],
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "atlassianProducts",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AtlassianProductsFragment"
                  }
                ],
                "type": "UnifiedAtlassianProductConnection",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UnifiedProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedQuery",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unifiedProfile",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "UnifiedProfile",
                "abstractKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "atlassianProducts",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAtlassianProductEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAtlassianProduct",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewHref",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "type": "UnifiedAtlassianProductConnection",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6dba7149ad9a27085c3682894effb09d",
    "id": null,
    "metadata": {},
    "name": "UnifiedProfileQuery",
    "operationKind": "query",
    "text": "query UnifiedProfileQuery(\n  $aaid: String\n  $username: String\n  $internalId: String\n) {\n  unified {\n    unifiedProfile(aaid: $aaid, unifiedProfileUsername: $username, internalId: $internalId) {\n      __typename\n      ... on UnifiedProfile {\n        ...UnifiedProfileFragment\n        id\n      }\n      ... on UnifiedQueryError {\n        identifier\n        message\n        extensions {\n          errorType\n          statusCode\n        }\n      }\n    }\n    atlassianProducts {\n      __typename\n      ... on UnifiedAtlassianProductConnection {\n        ...AtlassianProductsFragment\n      }\n    }\n  }\n}\n\nfragment AtlassianProductsFragment on UnifiedAtlassianProductConnection {\n  edges {\n    cursor\n    node {\n      id\n      productId\n      title\n      type\n      viewHref\n    }\n  }\n  totalCount\n}\n\nfragment UnifiedProfileFragment on UnifiedProfile {\n  id\n  bio\n  company\n  aaid\n  linkedinUrl\n  accountInternalId\n  location\n  products\n  role\n  internalId\n  username\n  websiteUrl\n  xUrl\n  youtubeUrl\n  isPrivate\n  isPersonalView\n  isLinkedView\n  isProfileBanned\n  isProfileOwnerConsented\n}\n"
  }
};
})();

(node as any).hash = "115e9f07c2f9dd14c0a4762e8efce747";

export default node;
